import {Pipe, PipeTransform} from '@angular/core';
import {Information} from '../../model/information';
import {UserRequest} from "../../model/UserRequest";

@Pipe({
  name: 'requesttype',
  standalone: true,
})
export class RequestTypePipe implements PipeTransform {
  transform(value: UserRequest[], type: string): UserRequest[] {
    if (value == null) {
      return value;
    }
    return value.filter(v => {
      return v.requestType === type;
    });
  }
}
